module.exports = __webpack_public_path__ + "img/PriceChangeOutlined.3a548f5a.svg";